export type Address = {
    ID: string;
    ClientName: string;
    Description: string;
    Address1: string;
    Address2: string;
    City: string;
    Province: string;
    Country: string;
    PostalCode: string;
    ModelID: string;
    IsReadonly: boolean;
    ParentModelID: string;
    ParentPropertyName: string;
    ListName: string;
    IsNewModel: boolean;
    SelfCheckForModification: boolean;
}

export const AddressRequiredField = [
    { name: "ClientName", text: "Nom"},
    { name: "Address1", text: "Adresse"},
    { name: "City", text: "Ville"},
    { name: "Province", text: "Province"},
    { name: "Country", text: "Pays"},
    { name: "PostalCode", text: "Code postal"}
];